import { mapState } from 'vuex'
import { needList, forums, serviceList } from 'js/activityArr'
import { Agetmeta } from '@/service/app'
import { getTicketList } from '@/service/vbef'
import buildTree from 'js/buildTree'
import filter from 'js/filter'
const MOBILE_REGEX = /^1[3-9]\d{9}$/
const signUpMixins = {
  data() {
    return {
      forums,
      needList,
      serviceList,
      currentForm: {
        name: '',
        compName: '',
        entityId: 0,
        department: '',
        title: '',
        companyNatureId: null,
        companyNatureOtherTagName: '',
        forums: [],
        need: [],
        needother: '',
        service: '',
        serviceother: '',
        activityTicketId: null,
        mobile: '',
        mobileAreaCode: '86',
        mobileVerifyCode: '',
      },
      needother: false,
      serviceother: false,
      compNTother: '',
      companyNatureTags: [],
      companyNatureTree: [],

      ticketList: [],
      currentTicket: {},

      ruleValidate2: {
        name: [
          {
            required: true,
            message: filter.dealLanguage('请填写姓名', 'Please fill in your name'),
            trigger: 'blur',
          },
        ],
        compName: [
          {
            required: true,
            message: filter.dealLanguage('请搜索并选择公司', 'Please search and select a company'),
            trigger: 'change',
          },
        ],
        department: [
          {
            required: true,
            message: filter.dealLanguage('请填写部门', 'Please fill in the department'),
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: filter.dealLanguage('请填写职位', 'Please fill in the position'),
            trigger: 'blur',
          },
        ],
        companyNatureId: [
          {
            required: true,
            type: 'number',
            message: filter.dealLanguage('请选择公司性质', 'Please select'),
            trigger: 'change',
          },
        ],
        companyNatureOtherTagName: [
          {
            required: true,
            message: filter.dealLanguage('请填写具体性质', 'Please fill in the specific nature'),
            trigger: 'blur',
          },
        ],
        forums: [
          {
            required: true,
            type: 'array',
            message: filter.dealLanguage('请选择会议或活动', 'Please select a meeting or event'),
            trigger: 'change',
          },
        ],
        need: [
          {
            required: true,
            max: 3,
            min: 3,
            type: 'array',
            message: filter.dealLanguage(
              '请选出最重要的3项需求',
              'Please select the top 3 requirements'
            ),
            trigger: 'change',
          },
        ],
        service: [
          {
            required: true,
            message: filter.dealLanguage('请选择是否需要', 'Please select whether you need'),
            trigger: 'change',
          },
        ],
        activityTicketId: [
          {
            required: true,
            type: 'number',
            message: filter.dealLanguage('请选择门票', 'Please select your ticket'),
            trigger: 'change',
          },
        ],
        mobileVerifyCode: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写正确的验证码',
              'Please fill in the correct verification code'
            ),
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的手机号', 'Please enter your mobile number'),
            trigger: 'blur',
          },
          {
            type: 'number',
            message: filter.dealLanguage(
              '手机号格式不正确',
              'The phone number format is incorrect'
            ),
            trigger: 'blur',
            transform: (value) => {
              // Mobile validation only applies to Chinese numbers (area code 86)
              // For other countries, skip the regex validation
              return MOBILE_REGEX.test(value) ? Number(value) : false
            },
          },
        ],
      },

      partnerList: [],
      partnerSingle: false,
      currentPartnerId: 0,
      currentPartner: {},
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      appMobileAreaCodeDtos: (state) => state.appMobileAreaCodeDtos,
      activityId: (state) => state.activityId,
      activityDetail: (state) => state.activityDetail,
      user: (state) => state.user,
      isWeixinBrowser: (state) => state.isWeixinBrowser,
      vbef_path: (state) => state.vbef_path,
      index2_path: (state) => state.index2_path,
      language: (state) => state.language,
    }),
  },
  methods: {
    async Agetmeta() {
      let res = await Agetmeta({
        metaNameList: ['companyNatureTags'],
      })
      if (res.code != 0) return
      this.$set(this.$data, 'companyNatureTags', res.data.companyNatureTags)
      res.data.companyNatureTags.forEach((tag) => {
        tag.label = filter.dealLanguage(tag.name, tag.enName)
      })
      const tree = buildTree(res.data.companyNatureTags)
      this.companyNatureTree = [...tree]
      console.log(this.currentForm.companyNatureId)
      this.handleChangeNT(this.currentForm.companyNatureId, 1)
    },
    async getTicketList() {
      let res = await getTicketList({
        actId: this.activityId,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'ticketList', res.data)
      }
    },
    handleChangeNT(value, isfirst = 0) {
      if (!isfirst) this.currentForm.companyNatureOtherTagName = ''
      if (!value || !this.companyNatureTags.length) {
        this.compNTother = ''
        return
      }
      let item = this.companyNatureTags.find((a) => a.id === value)
      if (
        item.name.indexOf('其他') > -1 ||
        item.name.indexOf('Other') > -1 ||
        item.name.indexOf('other') > -1
      ) {
        this.compNTother = item.name
      } else {
        this.compNTother = ''
      }
    },
    handleChangeNeed(arr) {
      this.needother = false
      for (let item of arr) {
        if (item.indexOf('其他') > -1 || item.indexOf('Other') > -1 || item.indexOf('other') > -1) {
          this.needother = true
          break
        }
      }
    },
    handleChangeService(value) {
      this.serviceother =
        value.indexOf('其他') > -1 || value.indexOf('Other') > -1 || value.indexOf('other') > -1
    },
    handleSeletTicket(value) {
      let item = this.ticketList.find((a) => a.id === value)
      this.currentTicket = { ...item }
    },
    handleChangeSingle() {
      this.$refs['current-form'].resetFields()
      this.currentPartnerId = 0
      this.currentPartner = {}
      this.ininUserInfo()
    },
    handleChangePartner() {
      if (this.currentPartnerId) {
        let item = this.partnerList.find((a) => a.id === this.currentPartnerId)
        this.currentPartner = { ...item }

        this.currentForm.name = item.name || ''
        this.currentForm.compName = item.compName || ''
        this.entityKeyword = item.compName || ''
        this.currentForm.entityId = item.entityId || 0
        this.currentForm.department = item.department || ''
        this.currentForm.title = item.title || ''
        this.currentForm.companyNatureId = item.companyNatureId || null
        this.currentForm.companyNatureOtherTagName = item.companyNatureOtherTagName || ''
        this.currentForm.mobile = item.mobile
        this.currentForm.mobileAreaCode = item.mobileAreaCode
        this.currentForm.mobileVerifyCode = item.mobileVerifyCode
      } else {
        this.currentPartner = {}
      }
    },
    async getPartnerList() {
      let res = await getPartnerList({
        page: 1,
        size: 99999,
      })
      if (res.code == 0) {
        this.$set(this, 'partnerList', res.data.partner)
      }
    },
  },
}
export { signUpMixins }